export class DocumentExchangeDto {

  public readonly id!: string;
  public readonly sourceCurrencyCode!: string;
  public readonly targetCurrencyCode!: string;
  public readonly rate!: number;
  public readonly source!: string;

  constructor(init?: Partial<DocumentExchangeDto> | undefined) {
    Object.assign(this, init);
  }
}
